export default {"src":"/_next/static/media/enterprise-openwebui-service.11ed32e5.svg","height":1080,"width":1920,"blurWidth":0,"blurHeight":0};